import type { ReactElement, ReactNode } from 'react';

export enum FeaturesColorTypes {
    lime = 'lime',
}

export interface IFeatureData {
    /**
     * Вместо text лучше использовать ?textJsx, если есть
     * В старом компоненте string использовался в dangerouslySetInnerHTML
     * @deprecated
     */
    text: string;
    textJsx?: ReactNode;
    key: string;
    icon?: ReactElement;
    primaryColor?: boolean;
    color?: FeaturesColorTypes;

    onClick?();

    delimiters?: boolean;
    // Показывает, что фича выключена для данного тарифа, в интерфейсе затемнена и с иконкой крестика по умолчанию
    disabled?: boolean;
    usePropsIcon?: boolean;
    noIcon?: boolean;
}
